import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Pets = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12.715 4.002L12.667 4a.671.671 0 01.408.14l.027.022a.67.67 0 01.017.015l.02.018 1.874 1.874 4.493 1.205a.667.667 0 01.49.563l.004.081a4.188 4.188 0 01-2.388 3.781l-.105.047 2.459 7.377a.667.667 0 01-.554.872l-.079.005h-2.666a.667.667 0 01-.604-.384l-.029-.072-1.057-3.172-.687.459c.215.299.35.66.373 1.051l.004.118v1.333a.667.667 0 01-.59.663L14 20H7.333a.667.667 0 01-.662-.589l-.004-.078V18.6a3.335 3.335 0 01-2.664-3.122L4 15.333v-1.562c0-.825.306-1.619.855-2.229l.122-.127a2 2 0 00.09-2.733l-.09-.096-.782-.781a.667.667 0 01.88-.999l.063.056.781.781a3.334 3.334 0 01.115 4.594l-.115.12c-.344.344-.55.8-.581 1.282l-.005.132v1.562a2 2 0 001.212 1.839l.122.047V16a6.002 6.002 0 015.129-5.937l.204-.026v-5.37a.664.664 0 01.195-.472l.013-.012a.67.67 0 01.06-.05l-.073.062a.67.67 0 01.394-.19L12.667 4h.013a.67.67 0 01.035.002zm.618 2.274v4.39a.667.667 0 01-.666.667 4.667 4.667 0 00-4.664 4.507L8 16l-.001 1.984L8 18v.667h5.333V18a.666.666 0 00-.589-.662l-.077-.005h-1.334a.667.667 0 01-.077-1.329l.077-.004h1.334c.137 0 .272.014.402.04l1.895-1.261a.667.667 0 01.972.268l.03.076 1.18 3.544h1.262l-2.374-7.123a.667.667 0 01.398-.835l.073-.022a2.855 2.855 0 002.109-2.22l.008-.05-4.128-1.106a.667.667 0 01-.233-.115l-.066-.058-.862-.862zm2 1.717c.342 0 .624.258.663.59l.004.084a.667.667 0 01-1.329.077l-.004-.084c0-.368.298-.667.666-.667z"
        id="prefix__a-pets"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b-pets" fill="#fff">
        <use xlinkHref="#prefix__a-pets" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#prefix__a-pets" />
      <g
        mask="url(#prefix__b-pets)"
        fill={props.color || theme.palette.grey600}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
